module.exports = __webpack_public_path__ + "img/1@2x.e93d7510.png";